import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 批量添加不参与统计的学生
  batchAddExclusiveStudent: params =>
    http.post(URL.API_ATSCHOO_BARCH_ADD_EXCLUDE_STUDENT, params),
  // 批量删除不参与统计的学生
  batchDeleteExclusiveStudent: params =>
    http.post(URL.API_ATSCHOO_BARCH_DELETE_EXCLUDE_STUDENT, params),
  // 班级学生在校情况实时统计
  getClassStatList: params =>
    http.post(URL.API_ATSCHOOL_GET_CLASS_STAT, params),
  // 根据状态查询班级学生在校情况实时统计
  getClassStatListByStatus: params =>
    http.post(URL.API_ATSCHOOL_GET_CLASS_STAT_BY, params),
  // 查询班级学生状态列表
  getClassStudentList: params =>
    http.post(URL.API_ATSCHOOL_GET_CLASS_STUDENT, params),
  // 部门学生在校情况实时统计（根据角色统计）
  getDeptStat: params => http.post(URL.API_ATSCHOOL_GET_DEPT_STAT, params),
  // 分页查询不参与统计的学生
  getPageExclusiveStudent: params =>
    http.post(URL.API_ATSCHOO_EXCLUDE_STUDENT, params),
  // 查询学生进出校记录列表
  getStudentAccessRecords: params =>
    http.post(URL.API_ATSCHOO_GET_STUDENT_RECORDS, params),
  // 查询学生每日在校状态列表 1：正常 0：异常 -1：未知
  getStudentDailyStatusList: params =>
    http.post(URL.API_ATSCHOO_GET_STUDENT_DETAILS, params),
  // 修改进出校日历状态
  modifyDaily: params =>
    http.post(URL.API_ATSCHOO_MODIFY_STUDENT_DAILY, params),
  // 搜索进出校学生
  searchStudent: params => http.post(URL.API_ATSCHOO_SEARCH_STUDENT, params),
  // 搜索进出校组
  searchStudentGroup: params =>
    http.get(URL.API_ATSCHOO_SEARCH_STUDENT_GROUP, params),
  // 获取进出校日历状态
  getAtSchoolTaskInfo: params => http.get(URL.API_ATSCHOOL_GET_TASK_ID, params),
  // 修改进出校日历状态V2
  modifyAtSchoolDailyV2: params =>
    http.post(URL.API_ATSCHOOL_MODIFY_DAILY_V2, params)
}
